import React, { FC, useEffect, useState } from 'react'
import styles from './SearchPageContents.module.scss'
import { Link } from 'react-router-dom'
import { QueryType } from '../../ducks/actresses/types'
import InputRange from 'react-input-range'
import { RouteComponentProps } from 'react-router'
import './OverrideReactInputRange.scss'
import Moment from 'moment'

const MIN_CUP = 1
const MAX_CUP = 9
const CUP_LIST = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I ~']

const SearchPageContents: FC<RouteComponentProps> = ({history}) => {
  const [cup, setCup] = useState({min: 3, max: 5})
  const [age, setAge] = useState({min: 20, max: 30})
  const [name, setName] = useState(null)

  const handleCup = (value: any) => {
    setCup({
      min: value.min,
      max: value.max
    })
  }

  const handleAge = (value: any) => {
    setAge({
      min: value.min,
      max: value.max
    })
  }

  const handleName = (event: any) => {
    event.persist()
    setName(event.target.value)
  }

  const handleSubmit = () => {
    const gteBirthday = Moment().add(-age.max, 'years').format('YYYY-MM-DD')
    const lteBirthday = Moment().add(-age.min, 'years').format('YYYY-MM-DD')
    const cupList = () => {
      if (cup.max == MAX_CUP) return CUP_LIST.slice(cup.min)
      return CUP_LIST.slice(cup.min, cup.max)
    }

    const query: QueryType = {
      cup: cupList(),
      gteBirthday,
      lteBirthday,
    }

    if (name != null) { query.name = encodeURI(name || '') }

    const params = new URLSearchParams()
    Object.keys(query).map(key => {
      params.append(key, query[key] as string)
    })
    history.push('/result?' + params.toString())
  }

  return (
    <div className={ styles.mainContents }>
      <div className={ styles.sectionTitle }>
        検索項目を入力
      </div>
      <div className={ styles.formContent }>
        <div className={ styles.label }>
          カップ { CUP_LIST[cup.min -1] } ~ { CUP_LIST[cup.max -1] }
        </div>
        <div className={styles.sliderContainer}>
          <InputRange
            maxValue={MAX_CUP}
            minValue={MIN_CUP}
            formatLabel={value => CUP_LIST[value - 1]}
            step={1}
            value={cup}
            onChange={value => handleCup(value)}
          />
        </div>
      </div>

      <div className={ styles.formContent }>
        <div className={ styles.label }>
          年齢 { age.min }歳 ~ { age.max }歳
        </div>
        <div className={styles.sliderContainer}>
          <InputRange
            maxValue={45}
            minValue={20}
            formatLabel={value => `${value} 歳`}
            step={1}
            value={age}
            onChange={value => handleAge(value)}
          />
        </div>
      </div>

      <div className={ styles.formContent }>
        <div className={ styles.label }>
          女優名
        </div>
        <div className={ styles.keywordField }>
          <input
            type="text"
            id="keyword"
            name="keyword"
            placeholder="女優を名前で検索"
            value={ name || ''}
            onChange={ handleName }
          />
        </div>
      </div>

      <div className={ styles.searchButton } onClick={handleSubmit}>
        女優を探す
      </div>
      <Link to="/">
        <div className={ styles.topButton }>
          トップに戻る
        </div>
      </Link>
    </div>
  )
}

export default SearchPageContents